export default __webpack_public_path__ + "static/media/pk.8835c095.svg";